import type { TrackingStrategy } from '@eversports/amplitude-react/AmplitudeProvider'
import type { SessionReplayPluginModule } from '@eversports/amplitude-react/core/config'
import { b2cAmplitudeConfig, SESSION_REPLAY_FLOOR } from '@eversports/amplitude-react/core/presets'
import type { Language } from '@eversports/language'

import { getWindow } from './window'

export interface AmplitudeOptions {
  trackingStrategy?: TrackingStrategy
  hasGuidesAndSurveys?: boolean
  /** `() => import('@amplitude/plugin-session-replay-browser')`, so the app's bundler splits the plugin. */
  loadSessionReplayPlugin?: () => Promise<SessionReplayPluginModule>
}

export const getClientAmplitudeConfig = (language: Language, options: AmplitudeOptions = {}) =>
  b2cAmplitudeConfig({
    apiKey: getWindow().env.AMPLITUDE_PROJECT_API_KEY,
    guidesAndSurveys: options.hasGuidesAndSurveys ? { locale: language } : undefined,
    loadSessionReplayPlugin: options.loadSessionReplayPlugin,
    sessionReplay: options.loadSessionReplayPlugin && SESSION_REPLAY_FLOOR,
  })
